import request from '@/utils/request'
/*获取列表*/
export function query_page(data) {
  return request({
    url: '/icps/system/sign/basics/analysis/query_page',
    method: 'post',
    data
  })
}